import Tenant from '../models/Tenant';
import * as Types from './types';
import Team from '../models/Team'
import User from '../models/User'
import Scenarios from "../models/Scenarios";
import Order from "../models/Order";
import Customer from '../models/Customer';
import Person from '../models/Person'
import Shipment from '../models/Shipment'
const isEqual = require('lodash.isequal');
const axios = require('axios')

const b = async (url) => {
    if(url) {
        try {
            let image = await axios.get(url)
            return await "data:image/png;base64," + Buffer.from(image.data).toString('base64')
        } catch(e) {
            console.log("error : ", e)
        }
    }
    return await url
}


export default {

    async SYNC({ commit }, richpanelData) {
        try {
            const previousDataOfUser = localStorage.getItem('previousDataOfUser')
            let canUpdateData = true;
            if(previousDataOfUser && isEqual(richpanelData, JSON.parse(previousDataOfUser))) {
                canUpdateData = false;
            } else {
                localStorage.setItem('previousDataOfUser', JSON.stringify(richpanelData))
            }
            richpanelData.canUpdateData = canUpdateData;
            richpanelData.previous_user_properties = null;
            try {
                if(previousDataOfUser){
                    const previusData = JSON.parse(previousDataOfUser);
                    richpanelData.previous_user_properties = previusData.user_properties || null;
                }
            } catch(e){
                console.log(e)
            }
            const { data, errors } = await Tenant.syncMessenger(richpanelData);
            if (errors && errors.length > 0) {
                throw new Error(errors[0].message);
            }

            if (data) {
                commit(Types.SYNC, data);
                return;
            }

            throw new Error('Tenant Id Not Found');
        } catch(e){
            if(localStorage.getItem('rpMessengerAuth')){
                localStorage.removeItem('rpMessengerAuth')
                parent.location.reload();
                return;
            }
            throw e
        }
        
    },

    async GET_PROPERTIES_DATA({ commit, getters },) {
        const {
            tenantProperties = []
        } = getters;
        if(tenantProperties.length>0){
            return;
        }
        const { data, errors } = await Tenant.getPropertiesData();
        if (errors && errors.length > 0) {
            throw new Error(errors[0].message);
        }

        if (data) {
            commit(Types.SET_PROPERTIES_DATA, data);
            return;
        }

        throw new Error('Tenant Id Not Found');
    },
    async CREATE_CONV_EXTERNAL_HELPDESK({ commit }, payload) {
        if(!payload){
            throw new Error("Please provide the inputs");
        }
        const { data } = await Customer.createConvExternalHelpdesk(payload);

        if (data && data.status) {
            return { status: true };
        }
        return {
            status: false,
            message: data.message || "Error occured"
        }
    },

    async FETCH_ALL_AGENT({ commit, getters }, tenantId) {
        const { data, errors } = await User.fetchAllUsers(tenantId);
        if (errors && errors.length > 0) {
            throw new Error(errors[0].message);
        }
        if (data) {
            let agentList = data.data
            commit(Types.FETCH_AGENT, agentList);
            return;
        }
    },

    async SET_SELECTED_CONVERSATION({ commit, getters }, conversation) {
        commit(Types.SET_SELCTED_CONVERSATION, conversation);
    },

    async FETCH_TEAM_DETAILS({commit, getters}, tenantId) {
        const a = await Team.fetchTeamInfo(tenantId);
        commit(Types.SET_TEAM_DETAILS, a.data.data)
    },
    async SET_ACTIVE_AGENTS({ commit }, activeAgents) {
        commit(Types.SET_ACTIVE_AGENTS, activeAgents)
    },
    async SET_USER_PROPERTIES( { commit, getters }, { properties }) {
        const data = {
            userProperties: { ...getters.userProperties, ...properties},
        }
        commit(Types.SET_USER_PROPERTIES, data)
    },

    UPDATE_AGENT_PROPERTIES({ commit, getters}, { agentId, isChatAccess }) {
        commit(Types.SET_AGENT_PROPERTIES, { agentId, isChatAccess })
    },

    async FETCH_ALL_SCENARIOS({commit,getters}, brandId) {
        const {data, errors} = await Scenarios.getAllScenarios(brandId);
        if (errors && errors.length > 0) {
            throw new Error(errors[0].message);
        }
        if (data) {
            commit(Types.FETCH_SCENARIOS, data.data.LIVE);
        }
    },

    async FETCH_ALL_ORDER_BY_UID({commit}, { personId, tenantId, page, appClientId, offset=0 }) {
        let orders = await Order.getAllOrdersByUid({personId, tenantId, page, appClientId, offset});
        let addMoreOrders = page > 1 ? true : false;
        if(orders && orders.data && orders.data.length)
        commit(Types.SET_ORDERS, { ordersData: orders.data, addMoreOrders } )
    },

    async FETCH_PERSON_ID({commit,state},{cookiedId,tenantId}){
       const personId = await Scenarios.getPersonIdFromCookieId(cookiedId,tenantId);
        commit(Types.SET_PERSON_ID,personId);
    },

    async FETCH_CUSTOMER_DATA_BY_PERSON_ID({ commit, state}, { personId }) {
        const {data, errors} = await Customer.getCustomerData(personId);
        if (errors && errors.length > 0) {
            throw new Error(errors[0].message);
        }
        if (data) {
            commit(Types.SET_CUSTOMER_PROPERTIES, data.response);
        }
    },
    async SAVE_SCENARIO_PRECHAT_PROPERTIES({ commit, state }, { peopleProps, conversationProps }) {
        const scenarioprechatPropsObject = {
            scenarioConversationProperties: [], 
            scenarioPeopleProperties: []
        };

        if(peopleProps.length > 0) {
            scenarioprechatPropsObject.scenarioPeopleProperties = peopleProps;
        }
        if(conversationProps.length > 0) {
            scenarioprechatPropsObject.scenarioConversationProperties = conversationProps
        }

        commit(Types.SET_SCENARIO_PRECHAT_PROPERTIES, scenarioprechatPropsObject)
    },

    async SEND_CODE_FOR_LOGIN({ commit }, { appClientId, userLoginId, userIdType, phoneCode = "" }) {

        try {
            commit(Types.SET_LOADING, { storeName: 'loginScreenStore', actionName: 'SEND_CODE_FOR_LOGIN', loadingStatus: true })
            commit(Types.SET_ERRORS, { storeName: 'loginScreenStore', actionName: 'SEND_CODE_FOR_LOGIN', errorMessage: '' })
            commit(Types.SET_ERRORS, { storeName: 'loginScreenStore', actionName: 'VERIFY_CODE_FOR_LOGIN', errorMessage: '' })

            const {
                status, message, sourcePersonId
            } =  await Person.sendCode({
                appClientId,
                userLoginId,
                userIdType,
                phoneCode,
            });
            if (!status) {
                throw new Error(message);
            }
            commit(Types.SET_LOADING, { storeName: 'loginScreenStore', actionName: 'SEND_CODE_FOR_LOGIN', loadingStatus: false })
            if (status && sourcePersonId) {
                return {
                    message: message,
                    status: true,
                    sourcePersonId
                }
            }
        } catch(e) {
            console.log(e)
            const errorMessage = e.message || 'Failed to send code';
            commit(Types.SET_ERRORS, { storeName: 'loginScreenStore', actionName: 'SEND_CODE_FOR_LOGIN', errorMessage })
            commit(Types.SET_LOADING, { storeName: 'loginScreenStore', actionName: 'SEND_CODE_FOR_LOGIN', loadingStatus: false })
            return {
                message: errorMessage,
                status: false
            }
        }
        
    },


    async TRY_ORDER_LOGIN({ commit }, { ...payload }) {
		try {
            commit(Types.SET_LOADING, { storeName: 'loginScreenStore', actionName: 'SEND_CODE_FOR_LOGIN', loadingStatus: true })
            commit(Types.SET_ERRORS, { storeName: 'loginScreenStore', actionName: 'SEND_CODE_FOR_LOGIN', errorMessage: '' })
            commit(Types.SET_ERRORS, { storeName: 'loginScreenStore', actionName: 'VERIFY_CODE_FOR_LOGIN', errorMessage: '' })

            const {
                status, message, encryptedData, userProperties,
            } = await Person.tryOrderLogin({
				...payload
            });
    
            if (!status || !encryptedData) {
                throw new Error(message);
			}

			commit(Types.SET_LOADING, { storeName: 'loginScreenStore', actionName: 'SEND_CODE_FOR_LOGIN', loadingStatus: false })

			return {
				message: message,
				status: true,
				encryptedData,
				userProperties,
			}

        } catch(e) {
            console.log(e)
            const errorMessage = e.message || 'Failed to verify';
            commit(Types.SET_ERRORS, { storeName: 'loginScreenStore', actionName: 'SEND_CODE_FOR_LOGIN', errorMessage })
            commit(Types.SET_LOADING, { storeName: 'loginScreenStore', actionName: 'SEND_CODE_FOR_LOGIN', loadingStatus: false })
            return {
                message: errorMessage,
                status: false
            }
        }
    },


    async VERIFY_CODE_FOR_LOGIN({ commit }, { appClientId, userLoginId, userIdType, code, sourcePersonId }) {

        try {
            commit(Types.SET_LOADING, { storeName: 'loginScreenStore', actionName: 'VERIFY_CODE_FOR_LOGIN', loadingStatus: true })
            commit(Types.SET_ERRORS, { storeName: 'loginScreenStore', actionName: 'VERIFY_CODE_FOR_LOGIN', errorMessage: '' })


            if(!code || !sourcePersonId) {
                commit(Types.SET_LOADING, { storeName: 'loginScreenStore', actionName: 'VERIFY_CODE_FOR_LOGIN', loadingStatus: false })
                commit(Types.SET_ERRORS, { storeName: 'loginScreenStore', actionName: 'VERIFY_CODE_FOR_LOGIN', errorMessage: 'Please enter login code' })
                return { status: false, message: "Please enter login code" };
            }

            const {
                status, message, encryptedData, userProperties,
            } = await Person.verifyCode({
                appClientId,
                userLoginId,
                userIdType,
                code,
                sourcePersonId
            });
    
            if (!status) {
                throw new Error(message);
            }

            commit(Types.SET_LOADING, { storeName: 'loginScreenStore', actionName: 'VERIFY_CODE_FOR_LOGIN', loadingStatus: false })

            if (encryptedData) {
                return {
                    message: message,
                    status: true,
                    encryptedData,
                    userProperties,
                }
            }
        } catch(e) {
            const errorMessage = e.message || 'Failed to verify code';
            commit(Types.SET_ERRORS, { storeName: 'loginScreenStore', actionName: 'VERIFY_CODE_FOR_LOGIN', errorMessage })
            commit(Types.SET_LOADING, { storeName: 'loginScreenStore', actionName: 'VERIFY_CODE_FOR_LOGIN', loadingStatus: false })
            return {
                message: errorMessage,
                status: false
            }
        }
        
    },

    async GET_ORDER_SHIPPING_DETAILS({commit}, {orderId, appClientId, tenantId}) {
        const shipmentDetails = await Shipment.getOrdersShippingDetails({ orderId, appId:appClientId, tenantId })
        commit(Types.SET_ORDER_SHIPMENT_DETAILS, shipmentDetails);
    },

    async RESET_ORDERS_DATA({commit}) {
        commit(Types.RESET_ORDERS_DATA)
    },

}
